import React, { useState } from 'react';
import { FormControl, FormLabel, Input, useToast } from '@chakra-ui/react';
import { uploadImage } from '../../api/resourceApi';

function ImageUploader({ label, OnUpload, accept = 'image/*' }) {
  const [fileUploadStatus, setFileUploadStatus] = useState('-1');
  const [isInProgress, setIsInProgress] = useState(false);
  const toast = useToast();

  const [inputId] = useState(
    `media-${label.replace(/\s+/g, '-')}-${Math.random().toString(36).substr(2, 9)}`
  );

  const handleFileChange = event => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    setFileUploadStatus('-1');
    setIsInProgress(true);
    const file = event.target.files[0];
    uploadImage(file)
      .then(result => {
        if (result.uploadStatus) {
          toast({
            title: 'Success',
            description: 'Media Uploaded Successfully.',
            status: 'success',
            duration: 5000,
            isClosable: true,
            position: 'top-right',
          });
          setFileUploadStatus('1');
          OnUpload(result.filename);
          setIsInProgress(false);
        } else {
          toast({
            title: 'Error',
            description: 'Error in media upload, Please try again.',
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top-right',
          });
          setFileUploadStatus('0');
          OnUpload(null);
          setIsInProgress(false);
        }
      })
      .catch(error => {
        console.log(error);
        toast({
          title: 'Error',
          description: 'Something went wrong, Please try again.',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
        setFileUploadStatus('0');
        setIsInProgress(false);
        OnUpload(null);
      });
  };

  return (
    <>
      <FormControl isDisabled={isInProgress}>
        <FormLabel m={0} className="file-upload-label" htmlFor={inputId}>
          {isInProgress
            ? 'Uploading...'
            : fileUploadStatus === '1'
              ? 'Change Media'
              : label}
        </FormLabel>
        <Input
          id={inputId}
          name="name"
          type="file"
          accept={accept}
          display="none"
          onChange={handleFileChange}
        />
      </FormControl>
    </>
  );
}

export default ImageUploader;
